













import { Component, Watch, Vue } from 'vue-property-decorator'
import eventModule from '@/store/event'

@Component({
  name: 'MessageAlert'
})
class MessageAlert extends Vue {
  private showAlert = false

  private get alertMessage() {
    return eventModule.message
  }

  private get alertType() {
    return eventModule.color
  }

  private get alertWidth() {
    return this.$vuetify.breakpoint.mdAndUp ? '50vw' : '90vw'
  }

  @Watch('alertMessage')
  private updateAlert(val: string) {
    if (val && val.trim().length > 0) {
      this.showAlert = true
    }
  }

  @Watch('showAlert')
  private alertCountdown() {
    setTimeout(() => {
      this.showAlert = false
      eventModule.resetMessage()
    }, 3000)
  }
}

export default MessageAlert
